export const TIERS = [
  {
    id: "mp3",
    name: "Standard MP3 Lease",
    features: ["Untagged MP3 File", "Up to 100,000 Audio Streams", "Non-Exclusive License", "PDF License Agreement"],
  },
  {
    id: "wav",
    name: "Premium Lease (WAV + Stems)",
    features: ["Untagged 24-bit WAV + MP3", "Full Trackout Stems", "Up to 500,000 Streams", "Non-Exclusive License"],
  },
  {
    id: "exclusive",
    name: "Exclusive Rights",
    features: ["Full Exclusive Ownership", "Beat Removed from Store", "Unlimited Everything", "Signed Exclusive Agreement PDF"],
  },
];

// Market-aligned ranges the producer prices within
export const TIER_RANGES = {
  mp3: { min: 14.99, max: 19.99 },
  wav: { min: 24.99, max: 29.99 },
  exclusive: { min: 149.99, max: 199.99 },
};

export const tierPrice = (beat, tierId, fallback) => {
  const p = beat?.prices?.[tierId];
  return typeof p === "number" ? p : fallback;
};
